import { submitForm } from './submit-form';
import { navigateToCheckout } from './navigate-to-checkout';
import { openPopup } from './open-popup';
export const FORM_ASYNC_ACTIONS = {
    submitForm,
    navigateToCheckout,
    openPopup,
};
//# sourceMappingURL=index.js.map